import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Anchor, Container, List, Stack, Text, Title } from "@mantine/core";
import { Fragment } from "react";
import { sectionId } from "../../content/render-html";
// Renderer for a LegalDoc. Container-agnostic: the consumer wraps it in its own
// Navbar / shell since agent-todo-ui and agent-gate-ui have different chrome.
export function LegalPage({ doc }) {
    return (_jsx(Container, { size: "md", py: "xl", children: _jsxs(Stack, { gap: "xl", children: [_jsxs("div", { children: [_jsx(Title, { order: 1, mb: "md", children: doc.title }), _jsxs(Text, { c: "dimmed", children: ["Last updated: ", doc.lastUpdated] })] }), _jsx(Stack, { gap: "lg", children: doc.sections.map((section, sectionIdx) => (_jsxs("section", { id: sectionId(section.title), children: [_jsx(Title, { order: 2, size: "h3", mb: "sm", children: section.title }), section.blocks.map((block, blockIdx) => (_jsx(Fragment, { children: renderBlock(block, blockIdx, section.blocks[blockIdx - 1]) }, blockIdx)))] }, sectionIdx))) })] }) }));
}
function renderBlock(block, idx, prev) {
    // Block spacing mirrors the original JSX:
    //   - first block has no extra margin (the section <Title> has mb="sm")
    //   - a paragraph after a list / paragraph / subheading gets mt="sm"
    //   - a paragraph before a list gets mb="sm"
    const isFirst = idx === 0;
    const topMargin = isFirst ? undefined : "sm";
    switch (block.kind) {
        case "p":
            return (_jsx(Text, { mt: topMargin, mb: undefined, children: block.runs.map((run, i) => (_jsx(RenderRun, { run: run }, i))) }));
        case "list":
            return (_jsx(List, { mt: prev?.kind === "p" || prev?.kind === "subheading" ? undefined : "sm", children: block.items.map((runs, i) => (_jsx(List.Item, { children: runs.map((run, j) => (_jsx(RenderRun, { run: run }, j))) }, i))) }));
        case "subheading":
            return (_jsx(Text, { fw: 600, mb: "xs", mt: isFirst ? undefined : "sm", children: block.text }));
    }
}
function RenderRun({ run }) {
    switch (run.kind) {
        case "text":
            return _jsx(_Fragment, { children: run.text });
        case "strong":
            return _jsx("strong", { children: run.text });
        case "em":
            return _jsx("em", { children: run.text });
        case "link":
            return (_jsx(Anchor, { href: run.href, ...(run.external && { target: "_blank", rel: "noopener noreferrer" }), children: run.text }));
    }
}
